import { convertLngLatToLatLng, convertMaplibrePointToLibmapPoint, } from '../convert.js';
export class MaplibreMouseEvent {
    #rawEvent;
    #features;
    constructor(rawEvent) {
        this.#rawEvent = rawEvent;
        this.#features = rawEvent.features ?? [];
    }
    get type() {
        return this.#rawEvent.type;
    }
    get latlng() {
        return convertLngLatToLatLng(this.#rawEvent.lngLat);
    }
    get point() {
        return convertMaplibrePointToLibmapPoint(this.#rawEvent.point);
    }
    get features() {
        return this.#features;
    }
    preventDefault() {
        this.#rawEvent.preventDefault();
    }
    static convert(callback) {
        return (e) => callback(new MaplibreMouseEvent(e));
    }
    static isType(eventType) {
        return (eventType === 'mousedown' ||
            eventType === 'mouseup' ||
            eventType === 'click' ||
            eventType === 'dblclick' ||
            eventType === 'mousemove' ||
            eventType === 'mouseover' ||
            eventType === 'mouseenter' ||
            eventType === 'mouseleave' ||
            eventType === 'mouseout' ||
            eventType === 'contextmenu');
    }
    static convertType(eventType) {
        return eventType;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW91c2UuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsiZXZlbnRzL21vdXNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBLE9BQU8sRUFDTixxQkFBcUIsRUFDckIsaUNBQWlDLEdBQ2pDLE1BQU0sZUFBZSxDQUFBO0FBRXRCLE1BQU0sT0FBTyxrQkFBa0I7SUFDOUIsU0FBUyxDQUFVO0lBQ25CLFNBQVMsQ0FBVztJQUVwQixZQUFZLFFBQTZDO1FBQ3hELElBQUksQ0FBQyxTQUFTLEdBQUcsUUFBUSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxTQUFTLEdBQUcsUUFBUSxDQUFDLFFBQVEsSUFBSSxFQUFFLENBQUE7SUFDekMsQ0FBQztJQUVELElBQUksSUFBSTtRQUNQLE9BQU8sSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUE7SUFDM0IsQ0FBQztJQUNELElBQUksTUFBTTtRQUNULE9BQU8scUJBQXFCLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQTtJQUNwRCxDQUFDO0lBQ0QsSUFBSSxLQUFLO1FBQ1IsT0FBTyxpQ0FBaUMsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQy9ELENBQUM7SUFDRCxJQUFJLFFBQVE7UUFDWCxPQUFPLElBQUksQ0FBQyxTQUFTLENBQUE7SUFDdEIsQ0FBQztJQUVELGNBQWM7UUFDYixJQUFJLENBQUMsU0FBUyxDQUFDLGNBQWMsRUFBRSxDQUFBO0lBQ2hDLENBQUM7SUFFRCxNQUFNLENBQUMsT0FBTyxDQUNiLFFBQXlDO1FBRXpDLE9BQU8sQ0FBQyxDQUFXLEVBQUUsRUFBRSxDQUFDLFFBQVEsQ0FBQyxJQUFJLGtCQUFrQixDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFDNUQsQ0FBQztJQUVELE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBaUI7UUFDOUIsT0FBTyxDQUNOLFNBQVMsS0FBSyxXQUFXO1lBQ3pCLFNBQVMsS0FBSyxTQUFTO1lBQ3ZCLFNBQVMsS0FBSyxPQUFPO1lBQ3JCLFNBQVMsS0FBSyxVQUFVO1lBQ3hCLFNBQVMsS0FBSyxXQUFXO1lBQ3pCLFNBQVMsS0FBSyxXQUFXO1lBQ3pCLFNBQVMsS0FBSyxZQUFZO1lBQzFCLFNBQVMsS0FBSyxZQUFZO1lBQzFCLFNBQVMsS0FBSyxVQUFVO1lBQ3hCLFNBQVMsS0FBSyxhQUFhLENBQzNCLENBQUE7SUFDRixDQUFDO0lBRUQsTUFBTSxDQUFDLFdBQVcsQ0FBQyxTQUFxQztRQUN2RCxPQUFPLFNBQVMsQ0FBQTtJQUNqQixDQUFDO0NBQ0QifQ==